<template>
  <v-menu ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
    :disabled="disabled"
    :class="menuClass"
  >
    <template v-slot:activator="{ on }">
      <v-text-field :value="date ? $moment(date).format('DD/MM/YYYY') : ''"
                    :class="inputClass"
                    :label="label"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    :hide-details="hideDetails"
                    :error-messages="errorMessages"
                    :disabled="disabled"
                    :clearable="clearable"
                    @click:clear="clearInput"/>
    </template>
    <v-date-picker v-model="date" no-title scrollable @input="menu = false"/>
  </v-menu>
</template>

<script>
  export default {
    name: 'date-field',
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      errorMessages: {
        type: Array,
        default: Array,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      hideDetails: {
        type: Boolean,
        default: false,
      },
      menuClass: {
        type: String,
        default: ''
      },
      inputClass: {
        type: String,
        default: ''
      },
      clearable: {
        type: Boolean,
        default: false
      }
    },
    data:() => ({
      menu: false,
      date: ''
    }),
    watch: {
      value: function (val) {
        this.date = val
      },
      date: function (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    mounted() {
      this.date = this.value
    },
    methods: {
      clearInput() {
        this.date = null
      }
    }
  }
</script>
